var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "14.1 82.9 1471.6 325.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1483.9 321L750 406.9 16 321l52.4-209.6c3.8-15 19.2-27 34.6-27h1293.8c15.4 0 30.8 12 34.5 27l52.6 209.6zM750.5 188.6c12.6 0 22.9-10.3 22.9-22.9 0-12.6-10.3-22.9-22.9-22.9-12.6 0-22.9 10.3-22.9 22.9s10.3 22.9 22.9 22.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#E0E7EC",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M1483.9 321L750 406.9 16 321l52.4-209.6c3.8-15 19.2-27 34.6-27h1293.8c15.4 0 30.8 12 34.5 27l52.6 209.6zM750.5 188.6c12.6 0 22.9-10.3 22.9-22.9 0-12.6-10.3-22.9-22.9-22.9-12.6 0-22.9 10.3-22.9 22.9s10.3 22.9 22.9 22.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottom);
export default __webpack_public_path__ + "static/media/bottom.5037b3722831e0232ae7187e29763483.svg";
export { ForwardRef as ReactComponent };